import { Rfqtable } from "../../components/datatable/Datatable";

const Rfq = () => {
  return <Rfqtable />;
};

export default Rfq;
